import http from "./HttpService";

const BASE_SERVICE_URL = "organization-service";

export default {
  getBranches(request) {
    return new Promise((resolve, reject) => {
      http
        .get(BASE_SERVICE_URL + "/branch/list", request.header)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getBranchesNearby(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          "estore-service/v2/customer/estore/branch/nearby",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getBranchesNearbyPublic(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          "estore-service/v2/public/customer/estore/branch/nearby",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getSpecificBranch(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/${request.is_public ? 'public' : 'customer'}/branch/view/${request.payload.branch_uuid}`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getFeaturedBannerList(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          "design-service/customer/get-design",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  }
};
